import { Component, Input } from "@angular/core";

@Component({
  selector: "error-message-cognito",
  templateUrl: "error-message-cognito.html",
})
export class ErrorMessageCognitoComponent {
  @Input() errorMessage;

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/components/common/error-message-cognito/error-message-cognito.ts